module.exports = __webpack_public_path__ + "static/media/logo.e6c86817.png";